import { type ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, description, actions }: PageHeaderProps): JSX.Element {
  return (
    <div className="flex items-start justify-between gap-6 px-8 py-6 border-b border-ax-line">
      <div className="min-w-0">
        {eyebrow && <p className="ax-eyebrow text-ax-text-tertiary mb-1.5">{eyebrow}</p>}
        <h1 className="font-display text-3xl text-ax-text-primary tracking-tighter">{title}</h1>
        {description && (
          <p className="ax-body-sm text-ax-text-tertiary mt-1.5 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
